import React from "react";

function Canvas_Curves() {
  return (
    <div>
      <h1>Canvas_Curves Component</h1>
      <p>This is the Canvas Curves tutorial page content.</p>
    </div>
  );
}

export default Canvas_Curves;
